<template>
  <div>
    <div class="container-fluid">
      <div class="row mt-5 justify-content-center">
        <div class="col-sm-6">
          <div ref="image" class="image">
            <div class="">
              <img
                src="@/assets/imgs/postal_01.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
            </div>

            <p>{{ formData.message }}</p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row mt-5">
        <div class="col-sm text-center">
          <div class="form-row">
            <div class="col">
              <div class="form-group">
                <label for="name">O seu nome</label>
                <input
                  type="text"
                  v-model="formData.name"
                  class="form-control"
                  id="name"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="email">O seu email</label>
                <input
                  type="email"
                  v-model="formData.email"
                  class="form-control"
                  id="email"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="mensagem">Escreva a Sua mensagem</label>
            <textarea
              maxlength="555"
              v-model="formData.message"
              class="form-control"
              id="mensagem"
              rows="3"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="email_send">Email do destinatário</label>
            <input
              type="text"
              v-model="formData.email_send"
              class="form-control"
              id="email_send"
              aria-describedby="emailHelp"
            />
            <small id="emailHelp" class="form-text text-muted">
              Para vários destinatários deve separar os endereços por
              vírgulas.</small
            >
          </div>

          <div class="form-group row">
            <div class="col-sm">
              <button class="btn btn-primary" @click.prevent="getCardImage">
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      formData: {
        email: "",
        name: "",
        email_send: "",
        message: "",
        image: null,
      },
    };
  },

  methods: {
    ...mapActions(["send"]),

    sendMail() {
      const params = this.formData;
      this.send(params)
        .then((response) => {
          this.$vToastify.success("Enviado com sucesso", "Cartão de natal");
          this.reset();
        })
        .catch((error) => {
          this.$vToastify.success("Erro ao enviar...", "Cartão de natal");
          setTimeout(() => this.reset(), 4000);
          return;
        });
    },

    async getCardImage() {
      const el = this.$refs.image;
      const options = {
        type: "dataURL",
        useCORS: true,
      };
      this.formData.image = await this.$html2canvas(el, options);
      this.sendMail();
    },

    reset() {
      this.formData = {
        email: "",
        name: "",
        email_send: "",
        message: "",
        image: null,
      };
    },
  },
};
</script>


<style scoped>
.image {
  position: relative;
  width: 500px; /* for IE 6 */
}

p {
  display: block;
  position: absolute;
  top: 120px;
  left: 60px;
  max-width: 380px;
  font-size: 12px;
  line-height: 15px;
  color: white;
  width: 100%;
  font-family: Georgia, 'Times New Roman', Times, serif;
}
</style>